<template>
  <div class="row h-100 no-gutters">
    <div class="auth-form mx-auto my-auto col-md-5 col-lg-3">
      <div class="card">
        <div class="card-body">
          <h1 style="text-align: center">
            <img
              id="main-logo"
              class="d-inline-block align-top mr-1"
              style="max-width: 100px;"
              src="@/assets/images/logo.png"
              alt="" />
          </h1>
          <d-alert
            v-if="authError"
            theme="warning"
            show>
            Błąd autoryzacji. Spróbuj ponownie
          </d-alert>
          <d-alert
            v-if="authBlocker"
            theme="danger"
            style="text-align: center"
            show>
            <span class="font-weight-light"> Użytkownik jest</span>
            <span class="font-weight-bold ml-1">zablokowany</span>
            <span class="font-weight-light ml-1">lub </span>
            <span class="font-weight-bold ml-1">nie został zatwierdzony</span>.
            <a href="javascript:window.location.reload();" class="alert-link font-weight-lighter">Odśwież stronę</a>
          </d-alert>

          <validation-observer ref="password-reset-form" tag="form">
            <validation-provider
              rules="email"
              name="email"
              v-slot="{ errors }">
              <div class="form-group">
                <label>Adres e-mail</label>
                <d-input
                  v-model="email"
                  name="email"
                  type="email"
                  :state="errors.length ? 'invalid' : null"
                  placeholder="Twój adres e-mail" />
                <div class="invalid-feedback">
                  {{ errors[0] }}
                </div>
              </div>
            </validation-provider>

            <validation-provider
              rules="required"
              name="password"
              v-slot="{ errors }">
              <div class="form-group">
                <label>Hasło</label>
                <d-input
                  v-model="password"
                  name="password"
                  type="password"
                  autocomplete="off"
                  :state="errors.length ? 'invalid' : null"
                  placeholder="********" />
                <div class="invalid-feedback">
                  {{ errors[0] }}
                </div>
              </div>
            </validation-provider>

            <button
              type="submit"
              class="btn btn-pill btn-accent d-table mx-auto"
              @click.prevent="login"
              :disabled="submitting">
              <template v-if="!submitting">Zaloguj</template>
              <template v-else>Logowanie&hellip;</template>
            </button>
          </validation-observer>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import api from '@/api.js';

export default {
  name: 'Login',
  data () {
    return {
      authError: false,
      submitting: false,
      authBlocker: false,
      email: '',
      password: ''
    }
  },
  methods: {
    login () {
      this.authError = false;
      this.authBlocker = false;
      this.submitting = true;

      this.$http.post(`${api}auth/login`, {
        email: this.email,
        password: this.password
      }).then((response) => {
        this.submitting = false;
        window.localStorage.setItem('token', response.data.access_token);
        this.$http.defaults.headers.Authorization = `Bearer ${response.data.access_token}`;
        this.$nextTick(() => {
          this.$router.push('/kokpit');
        });
      }).catch((error) => {
        console.log(error);
        if (error.response.data.error !== 'User is blocked or not confirmed') {
          this.submitting = false;
          this.authError = true;
        } else {
          this.authBlocker = true;
        }
      });
    }
  }
}
</script>
